import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Button, Col, Row, FormGroup, Label } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'

import Filters from './Filters'
import Recipients from './Recipients'
import {
  getTickets, updateFilters, updateAdvancedFilters, getAdvancedTickets,
  addSelectedFilters
} from 'redux/actions/marketing'
import { Radio } from 'components/Form'

const Step2SelectRecipients = (props) => {
  const dispatch = useDispatch()
  const { closeView, campaign } = props

  const [filteredUsers, setFilteredUsers] = useState([])
  const [countUsers, setCountUsers] = useState(0)
  const [selectedUsers, setSelectedUsers] = useState([])
  const [noUsersFound, setNoUsersFound] = useState(false)

  const [showTable, setShowTable] = useState(false)
  const [filterType, setFilterType] = useState('none')
  const [showAddButton, setShowAddButton] = useState(false)
  const [removePreview, setRemovePreview] = useState(false)

  const addRecipients = () => {
    // Go to step2 and show table with users
    dispatch(addSelectedFilters(filterType))

    props.sendUsers(selectedUsers)
    closeView()
  }

  // Handle users in Recipients component
  const handleSelectedUsers = (usersSelected, excludedIds = [], emptyExludedIds = false, filterType = null) => {
    let typeFilterUsed = campaign.typeFilterUsed
    const { advancedFilters = {}, filterTickets = {} } = campaign

    // Set typeFilterUsed === filterType if excludedIds.length && typeFilterUsed === 'none
    if(excludedIds.length && typeFilterUsed === 'none' && filterType) typeFilterUsed = filterType

    switch(typeFilterUsed) {
      case 'advancedFilters':
        dispatch(updateAdvancedFilters({ ...advancedFilters, excludeTicketsId: excludedIds }))
        break
      case 'filterTickets':
        dispatch(updateFilters({ ...filterTickets, excludeTicketsId: excludedIds }))
        break
      default:
        break
    }

    if (emptyExludedIds) return

    // when unselected all checkbox, users = []
    const countUsers = usersSelected.length ? Number(filteredUsers.size) - Number(excludedIds.length) : 0
    setCountUsers(countUsers)
    setSelectedUsers(usersSelected)
  }

  const getUsers = (value = null) => {
    const actionToCall = value === 'advanced' ? getAdvancedTickets() : getTickets()

    dispatch(actionToCall)
      .then((data) => {
        setFilteredUsers(data)
        const usersFound = data.size > 0
        setCountUsers(data.size)
        setShowTable(usersFound)
        setShowAddButton(usersFound)
        setNoUsersFound(!usersFound)
        setSelectedUsers(data.tableUsers)
        setRemovePreview(false)
        // delete excludedIds if previously selected
        handleSelectedUsers([], [], true)
      })
      .catch((error) => console.error(error))
  }

  const removeUsersPreview = () => {
    setRemovePreview(true)
    setShowAddButton(false)
  }

  const handleShowFilters = ({ target }) => {
    setNoUsersFound(false)
    const { value } = target
    switch(value) {
      case 'advancedFilters':
        setFilterType('advancedFilters')
        break
      case 'filterTickets':
        setFilterType('filterTickets')
        break
      default:
        setFilterType('none')
        break
    }
  }

  return (
    <>
      <Row className='my-3'>
        <Col xs={12}>
          <div className='select-recipients'>
            <Row className='header'>
              <Col className='col-md-auto' xs={11}>
                <h3>
                  <img src={'./img/icons/icon-user.svg'} alt={'user'} />
                  <span className='select-recipients-text'>{I18n.t('dashboard_select-recipients')}</span>
                </h3>
              </Col>
              <Col xs={1} className='col-md-auto text-right'>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' onClick={closeView} />
              </Col>
            </Row>

            <FormGroup check inline className='group-filters'>
              <Label check>
                <Radio
                  value="filterTickets"
                  name="filterTickets"
                  id="filterTickets"
                  label={I18n.t('dashboard_filters')}
                  onChange={handleShowFilters}
                  checked={filterType === 'filterTickets'}
                />
              </Label>
            </FormGroup>
            <FormGroup check inline className='group-filters-advanced'>
              <Label check>
                <Radio
                  value="advancedFilters"
                  checked={filterType === 'advancedFilters'}
                  onChange={handleShowFilters}
                  name='advancedFilters'
                  id='advancedFilters'
                  label={
                    <>
                      <b>{I18n.t('dashboard_rules')} </b>
                      <span style={{ fontSize: 12, color: '#777777', fontWeight: 'normal' }}>({I18n.t('dashboard_advanced')})</span>
                    </>
                  }
                />
              </Label>
            </FormGroup>

            {/** USER FILTERS */}
            {filterType === 'filterTickets'
              ? <Filters campaign={campaign} getUsers={getUsers} removePreview={removeUsersPreview} />
              : null
            }
            {filterType === 'advancedFilters'
              ? (
                <Filters
                //getUsers={getUsers}
                  advanced={true}
                  setNoUsersText={(value) => setNoUsersFound(value)}
                  removePreview={removeUsersPreview}
                  getUsersAdvancedFilters={getUsers}
                  campaign={campaign}
                />
              ) : null
            }

            {/** USER TABLE */}
            {showTable && !removePreview && <Recipients filterType={filterType} users={filteredUsers.tableUsers} handleSelectedUsers={handleSelectedUsers} />}

            {/** NO USERS FOUND */}
            {noUsersFound && (
              <Row className='no-users-found'>
                <Col className='text-center'>
                  <span>{I18n.t('no_users_found')}</span>
                </Col>
              </Row>
            )}

            {/** ADD recipients */}
            {showAddButton && showTable && (
              <Row style={{ padding: '20px' }}>
                <Col className='text-center'>
                  <Button color='primary' size='lg' onClick={addRecipients}>
                    <i className='fa fa-arrow-down'></i> {I18n.t('campaign_add_recipients', { count: countUsers })}
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

export default connect()(Step2SelectRecipients)
